import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDDialogActions, FDDialogContent, FDDialogTitle,
} from '@facet-wealth/design';
import { ActionPicker } from './ActionPicker';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const authenticationType = resource.selectedOptionPrompt('authenticationType');

  return (
    <>
      <FDDialogTitle value={`Disable ${authenticationType}?`} />
      <FDDialogContent>
        <FDBodyText value={`Your ${authenticationType} is currently enabled.`} />
      </FDDialogContent>
      <FDDialogActions>
        <ActionPicker authenticationFactorResource={resource} />
      </FDDialogActions>
    </>
  );
};

export default Layout;
